import React, { useEffect, useState } from "react";
import {
	Row,
	Col,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
} from "reactstrap";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import {
	AvField,
	AvForm,
	AvRadioGroup,
	AvRadio,
} from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import Select from "react-select";

const languages = ["en", "ar", "zh", "ru"];

function AddSubToMainModal({
	modal,
	toggle,
	Service,
	type,
	reqType,
	item,
	setShouldGetData,
}) {
	const [loading, setLoading] = useState(false);
	const [selectOptions, setSelectOptions] = useState([]);
	const [formData, setFormData] = useState({});

	useEffect(() => {
		Service.getDropDown().then((res) => {
			if (res && res.status === SuccessOk) {
				const options = res.data?.map((item) => {
					return {
						...item.name,
						id: item.id,
						label: item.name?.en,
					};
				});
				setSelectOptions([
					...options.filter((option) => option.id !== item?.id),
				]);
			}
		});
	}, []);

	// useEffect(() => {
	//     if (editObj ?.id) {
	//         unitTypesService.find(editObj ?.id).then(res => {
	//             if (res && res.status === SuccessOk) {
	//                 setFormData({ ...res ?.data ?.name})
	//             }
	//         })
	//     }

	// }, [])

	const handleValidSubmit = () => {
		let data = {};

		if (reqType === "main") {
			if (!formData.id) {
				return toast.error(`Select Main ${type}`);
			}
			data = {
				name: { ...item.name },
				parent_id: formData.id,
			};
		}
		if (reqType === "Sub") {
			data = {
				name: { ...item.name },
				parent_id: !!formData.id ? formData.id : null,
			};
		}
		setLoading(true);
		Service.update(item.id, data).then((res) => {
			if (res && res.status === SuccessOk) {
				toast.success(`${reqType} ${type} Added Sucessfully`);
				toggle();
				setTimeout(() => {
					setShouldGetData(true);
				}, 500);
			} else {
				setLoading(false);
			}
		});
	};

	return (
		<Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
			<ModalHeader toggle={toggle}>Add to Main {type}</ModalHeader>
			<ModalBody>
				<AvForm
					className="form-horizontal"
					onValidSubmit={(e, v) => handleValidSubmit(e, v)}>
					<Row className="mb-2">
						<Select
							placeholder={`Choose Main Type`}
							label={`Select Main ${type}`}
							onChange={(e) => {
								setFormData(e);
							}}
							options={selectOptions}
						/>
						{/* <AvRadioGroup name="unitTypes" required errorMessage="Pick one!">
                        {formData?.map((item, index) => {
                            return (
                                <AvRadio key={index} label={item?.name?.en} value={item?.name?.en} />
                            )
                        })}
                    </AvRadioGroup> */}
					</Row>
					<ModalFooter className="px-0">
						<button
							disabled={loading ? true : false}
							type="submit"
							size={"lg"}
							className="btn btn-success w-100">
							Add
						</button>
					</ModalFooter>
				</AvForm>
			</ModalBody>
		</Modal>
	);
}

export default AddSubToMainModal;
